document.addEventListener("DOMContentLoaded", initInfiniteScroll);

document.addEventListener("collection:updated", () => {
    initInfiniteScroll();
});
let observer = null;
function initInfiniteScroll() {

    const trigger = document.querySelector("#infinite-scroll-trigger");

    if (!trigger) return;

    let loading = false;
    const loader = document.querySelector("#infinite-loader");
        if (observer) {
            observer.disconnect();
        }

        observer = new IntersectionObserver(loadNextPage, {
            rootMargin: "300px"
        });

    observer.observe(trigger);

    async function loadNextPage(entries){

        if(!entries[0].isIntersecting) return;
        if(loading) return;
       loading = true;
       loader?.classList.remove("hidden");
        const nextLink=document.querySelector(".pagination-wrapper a[aria-label='Next page']");
       if(!nextLink){
            loader?.classList.add("hidden");
            observer.disconnect();
            return;
        }
        try{
            const response=await fetch(nextLink.href);
            const html=await response.text();
            const doc=new DOMParser().parseFromString(html,"text/html");
            const newProducts=doc.querySelectorAll("#product-grid > li");
            const grid=document.querySelector("#product-grid");
            newProducts.forEach(item=>{
                grid.appendChild(item);
            });
            const currentPagination=document.querySelector(".hidden-pagination");
            const newPagination=doc.querySelector(".hidden-pagination");
            if(currentPagination && newPagination){
                currentPagination.innerHTML=newPagination.innerHTML;
            }

            if(!document.querySelector(".pagination-wrapper a[aria-label='Next page']")){
                observer.disconnect();
            }

        }catch(e){
            console.log(e);
            loader?.classList.add("hidden");

        }
        loading=false;
        loader?.classList.add("hidden");
    }

}